import Cliente from "../Cliente";

export const login = values => {
  return Cliente.setBearerToken()
    .getCliente()
    .post(`${process.env.REACT_APP_API_URL}auth/login`, {
      ...values
    });
};
